const RECENT_SEARCH_KEY = 'RECENT_SEARCH';

export const setRecentSearch = destinationDetail => {
  const list = getRecentSearch();
  let foundKey = -1;
  list.forEach((l, i) => {
    if (l.destValue === destinationDetail.destValue) {
      foundKey = i;
    }
  });
  if (foundKey !== -1) {
    list.splice(foundKey, 1);
  }
  list.unshift(destinationDetail);
  while (list.length > 3) {
    list.pop();
  }
  localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(list));
};

export const getRecentSearch = () => JSON.parse(localStorage.getItem(RECENT_SEARCH_KEY) || '[]');
